import React from 'react';
import PropTypes from 'prop-types';
import {DrawerHandle} from '../DrawerHandle';
import './style.scss';

export function SectionHeader({toggleCollapse}) {
  return (
    <div className='notebookSections_header'>
      <DrawerHandle collapsed={false} toggleCollapse={toggleCollapse} />
      <span className='title'>
        <h6>Lab Notebook</h6>
        <h5>How could you make a coronavirus vaccine?</h5>
      </span>
    </div>
  );
}

SectionHeader.propTypes = {
  /**
   * Function invoked to collapse or expand NotebookDrawer
   */
  toggleCollapse: PropTypes.func.isRequired,
};
